import { TextField } from '@radix-ui/themes';
import styled, { css } from 'styled-components';

export const StyledTextFieldRoot = styled(TextField.Root)`
  ${props =>
    props.error &&
    css`
      border: 1px solid var(--error-11);
    `}
`;
